export const state = {
  currentPageSurvey: {},
}

export const getters = {
  currentPageSurvey(state) {
    return state.currentPageSurvey
  },
}

export const mutations = {
  SET_CURRENT_PAGE_SURVEY(state, survey) {
    state.currentPageSurvey = survey
  },
}
